import { Link } from 'react-router-dom';
import { FileQuestion, ShieldOff } from 'lucide-react';
import { EmptyState } from '@/design-system/Feedback';

/**
 * Terminal route states.
 *
 * A user who reaches a restricted route directly gets a clear explanation rather than a blank
 * screen. Hiding the navigation entry is a courtesy; this is what happens when someone follows a
 * link anyway. The server refuses the underlying request either way.
 */
export function ForbiddenPage() {
  return (
    <div className="mx-auto max-w-lg py-16">
      <EmptyState
        icon={<ShieldOff className="size-5" />}
        title="You do not have access to this area"
        description="Your account does not hold the permission this section requires. If you need it, ask an administrator to review your role."
        action={
          <Link
            to="/dashboard"
            className="inline-flex h-9 items-center rounded-md border border-border-default bg-surface px-3.5 text-small font-medium text-text-primary hover:bg-surface-hover"
          >
            Back to dashboard
          </Link>
        }
      />
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-lg py-16">
      <EmptyState
        icon={<FileQuestion className="size-5" />}
        title="Page not found"
        description="That address does not match anything in this application. It may have been moved, or the link may be incomplete."
        action={
          <Link
            to="/dashboard"
            className="inline-flex h-9 items-center rounded-md border border-border-default bg-surface px-3.5 text-small font-medium text-text-primary hover:bg-surface-hover"
          >
            Back to dashboard
          </Link>
        }
      />
    </div>
  );
}
